var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('top-page',[_vm._v("Shows")]),_c('loading',{attrs:{"loading":_vm.showsLoading}},[_c('dog-show-list',{attrs:{"shows":_vm.shows}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }